import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { Collapse, Spin } from "antd";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
	FormHeaderComponent
} from "../../components/styled/common";
import BackComponent from "../../components/BackComponent";
import CollapseExpandIcon from "../../components/CollapseExpandIcon";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useEventContext } from "../../context/EventContext/EventContext";
import { EventItemKeys, getEventItems } from "./constants";

const EventUpdate = () => {
	const { id } = useParams<{ id: string }>();
	const { updateEvent, getEventDetails, clearEventFormData, eventDetail, operationStatus, eventEditForm } = useEventContext();

	const isFetching = operationStatus.type === "loading" && operationStatus.operation === "fetch";

	useEffect(() => {
		if (id) {
			getEventDetails(id);
		}

		return () => {
			clearEventFormData();
		};
	}, [id]);

	const items = useMemo(
		() => {
			if(eventEditForm) {
				return getEventItems(eventEditForm.eventType, eventEditForm.eventDetail.hasCustomButton);
			}
			return [];
		},
		[eventEditForm?.eventType, eventEditForm?.eventDetail?.hasCustomButton]
	);

	return (
		<>
			<BackComponent text="Proje Listesine Dön" to="/events" />
			<ActionContainer>
				<Spin spinning={isFetching}>
					<ActionItemsContainer>
						<FormHeaderComponent>Proje Güncelleme</FormHeaderComponent>
						{eventDetail && (
							<Collapse
								key={eventDetail.eventId}
								items={items}
								expandIconPosition="end"
								bordered={false}
								ghost
								expandIcon={CollapseExpandIcon}
								defaultActiveKey={EventItemKeys}
							/>
						)}
						<SubmitButtonOverlay>
							<MainButtonComponent
								onClick={updateEvent}
								type="default"
								disabled={!eventDetail}
								loading={operationStatus.type === "loading" && operationStatus.operation === "update"}
							>
								Güncelle
							</MainButtonComponent>
						</SubmitButtonOverlay>
					</ActionItemsContainer>
				</Spin>
			</ActionContainer>
		</>
	);
};

export default EventUpdate;
